<template>
  <div class="bg-muted flex min-h-screen items-center justify-center p-4">
    <slot />
  </div>
</template>
